import { graphql } from "gql.tada";

export const TaggedEntryHeroFragment = graphql(
  `
    fragment TaggedEntryHeroFragment on TaggedEntryHero {
      sys {
        id
      }
      headline
      backgroundImage {
        url
        contentType
        title
      }
      backgroundVideo {
        url
        contentType
      }
      partnerLogosCollection(limit: 10) {
        items {
          url
          contentType
          title
        }
      }
      tagsCollection(limit: 20) {
        items {
          sys {
            id
          }
          tagLabel
        }
      }
    }
  `
);
